function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "55DF87DA-7799-46D5-9D00-687352E61A40");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Permatrol",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Pagina_principal",
  transform: "translate(-54.000000, -6.000000)"
}, React.createElement("g", {
  id: "PRIMERA"
}, React.createElement("g", {
  id: "face",
  transform: "translate(54.000000, 6.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  stroke: "#FFFFFF",
  x: 0.5,
  y: 0.5,
  width: 30,
  height: 30,
  rx: 3
}), React.createElement("path", {
  d: "M18.8518707,9.02339016 C17.5196435,9.02339016 17.1348554,9.54455846 17.1348554,10.6915381 L17.1348554,12.5940454 L20.6874612,12.5940454 L20.3323168,15.6693733 L17.1348554,15.6693733 L17.1348554,25 L12.8716703,25 L12.8716703,15.6693733 L10,15.6693733 L10,12.5940454 L12.8716703,12.5940454 L12.8716703,10.7434758 C12.8716703,7.64205112 14.2928289,6 18.2598666,6 C19.1186649,6 20.1251009,6.05219358 20.7467488,6.13048396 L20.7467488,9.02339016 L18.8518707,9.02339016",
  id: "Fill-1",
  fill: "#FFFFFF"
})))));

var SvgFace = function SvgFace(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/face.6746190b.svg";
export { ForwardRef as ReactComponent };